import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { customerNotesApi } from '../../lib/api';
import { Button } from '../ui/Button';

/** These are the existing order notes, never a complaint/conversation copy. */
export function OrderNotesPanel({ orderId, compact = false }: { orderId: string; compact?: boolean }) {
  const [content, setContent] = useState('');
  const [editing, setEditing] = useState(!compact);
  const client = useQueryClient();
  const key = ['customer-notes', 'order', orderId];
  const notes = useQuery({ queryKey: key, queryFn: async () => (await customerNotesApi.list({ orderId })).data.data });
  const save = useMutation({ mutationFn: () => customerNotesApi.create({ orderId, content: content.trim() }), onSuccess: () => { setContent(''); void client.invalidateQueries({ queryKey: key }); } });
  return <div className="mt-2 space-y-2">
    {!compact && <p className="text-xs text-text-muted">Wspólne z kartą zamówienia. Niewidoczne dla klienta.</p>}
    {notes.isPending && <p className="text-xs text-text-muted">Ładowanie...</p>}
    {notes.isError && <p className="text-xs text-danger">Nie udało się pobrać notatek.</p>}
    {notes.isSuccess && !notes.data?.length && <p className="text-xs text-text-muted">Brak notatek</p>}
    {notes.data?.map(note => <div key={note.id} className="rounded-lg bg-surface-hover p-2"><p className="text-xs whitespace-pre-wrap">{note.content}</p><p className="text-xxs text-text-muted mt-1">{new Date(note.createdAt).toLocaleString('pl-PL')}</p></div>)}
    {!editing && <button type="button" className="text-xs text-accent-primary" onClick={() => setEditing(true)}>Dodaj notatkę</button>}
    {editing && <>
    <label className="block text-xs">Notatka wewnętrzna<textarea rows={2} className="input w-full mt-1 text-xs" maxLength={10000} value={content} onChange={event => setContent(event.target.value)} disabled={save.isPending} /></label>
    {save.isError && <p className="text-xs text-danger">Nie udało się zapisać notatki.</p>}
    <Button size="sm" variant="secondary" loading={save.isPending} disabled={!content.trim() || save.isPending} onClick={() => save.mutate()}>Dodaj notatkę</Button>
    </>}
  </div>;
}
